import axios from 'axios'
import store from '../store'

const state = {
  limit: 10,
  companies: null,
  isFetching: false,
  isMore: false,
  isAdding: false,
  selectedIndex: null,
  isRequesting: false
}

const actions = {
  LOAD_COMPANY_ADDRESS: async ({commit}, payload) => {
    commit('SET_IS_REQUEST', true)
    let {data, status} = await axios.get('users-companies', {
      params: payload
    })
    if (status === 200) {
      (payload.page > 0) ? commit('ADD_COMPANY_ADDRESS_LIST', await data.user_companies) : commit('SET_COMPANY_ADDRESS_LIST', await data.user_companies)
    }
  },
  ADD_COMPANY: async ({commit}, submitData) => {
    commit('SET_ADDING_STATUS', true)
    let url = 'users-companies'
    let {data, status} = await axios.post(url, submitData.company)
    if (status === 201 || status === 200) {
      commit('SET_ADDING_STATUS', false)
      commit('ADD_NEW_COMPANY', await data.user_company)
      if (submitData.fromPage === 'checkout') {
        store.commit('booking/UPDATE_PRE_CHECKOUT_DATA', {key: 'user_company', value: data.user_company})
      }
    } else {
      commit('SET_ADDING_STATUS', false)
      alert(data.message)
    }
  },
  UPDATE_COMPANY: async ({commit}, submitData) => {
    commit('SET_ADDING_STATUS', true)
    let url = 'users-companies'
    let {data, status} = await axios.post(url, submitData.company)
    if (await status === 200) {
      commit('SET_ADDING_STATUS', false)
      commit('SET_COMPANY_DATA', data.user_company)
    } else {
      commit('SET_ADDING_STATUS', false)
      // alert(data.message)
    }
  },
  DELETE_COMPANY: async ({commit}, idCompany) => {
    const submitData = {id: idCompany}
    let url = 'users-companies'
    let {data, status} = await axios.delete(url, {data: submitData})
    if (await status === 200) {
      console.log('DELET SUCCESS', data)
      commit('DELETE_COMPANY_LIST')
    } else {
      alert(data.message)
    }
  },
  LOAD_COMPANY_DETAIL: async ({commit}, idCompanyAddress) => {
    let url = 'users-companies/' + idCompanyAddress
    let {data, status} = await axios.get(url)
    if (await status === 200) {
      console.log(await data, 'load company detail')
      commit('SET_COMPANY_DETAIL', await data)
    } else {
      alert(data.message)
    }
  }
}

const mutations = {
  SET_ADDING_STATUS: (state, data) => {
    state.isAdding = data
  },
  DELETE_COMPANY_LIST: (state, data) => {
    if (state.selectedIndex) {
      state.companies.splice(state.selectedIndex, 1)
    }
  },
  ADD_NEW_COMPANY: (state, data) => {
    state.companies.unshift(data)
    state.formAction = null
    state.isAdding = false
  },
  SET_IS_REQUEST: (state, data) => {
    state.isFetching = data
  },
  SET_COMPANY_ADDRESS_LIST: (state, companies) => {
    state.companies = companies
    state.isFetching = false
    state.isMore = true
    if (companies.length < state.limit) {
      state.isMore = false
    }
  },
  ADD_COMPANY_ADDRESS_LIST: (state, companies) => {
    state.isFetching = false
    state.isMore = true
    for (let key in companies) {
      state.companies.push(companies[key])
    }
  },
  SET_SELECTED_INDEX: (state, index) => {
    state.selectedIndex = index
  },
  UPDATE_FORM_DATA: (state, data) => {
    state.company[data.key] = data.value
  },
  SET_COMPANY_DETAIL: (state, company) => {
    state.isRequesting = false
    state.company = company
  },
  SET_COMPANY_DATA: (state, company) => {
    if (state.selectedIndex) {
      state.companies.splice(state.selectedIndex, 1, company)
    }
  }
}

const getters = {
  getState: state => {
    return state
  },
  isLoadMore: state => {
    return state.isFetching ? 'message.button.loading' : 'message.button.load_more'
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/company.address.js